<template>
    <div class="over-hide round-5" style="position: relative" :style="{width,height}">
        <div :id="id" :style="{width,height}"></div>
        <myNodataVchart v-if="rows.length == 0"></myNodataVchart>
    </div>
</template>

<script>
    import myNodataVchart from './myNodataVchart'
    export default {
        name: "myEcharsCol",
        components:{
            myNodataVchart
        },
        props:{
            id:{
                default: 'echart-col',
                type:String
            },
            rows: {
                default: () => [],
                type: Array
            },
            width:{
                default: '100%',
                type: String
            },
            height:{
                default: '300px',
                type:String
            },
            value_key:{
                type:String
            },
            line_value_key:{ //均线图
                default: '',
                type:String
            },
            name_key:{
                type:String
            },
            bar_width:{
                default: '20px',
            },
            bar_show_bg:{
                default: true,
            }
        },
        data:function(){
            return{
                myChart:null
            }
        },
        mounted:function(){
        },
        methods: {
        },
        beforeDestroy: function () {
            if(this.myChart){
                this.myChart.dispose();
            }
        },
        watch:{
            rows(newVal){
                var chartDom = document.getElementById(this.id);
                this.myChart = this.$echarts.init(chartDom);

                if(newVal.length > 0){
                    this.myChart.showLoading();
                    var option;

                    option = {
                        xAxis: {
                            type: 'category',
                            data: [],
                            axisLabel: {
                                rotate:30
                            },
                        },
                        yAxis: {
                            type: 'value'
                        },
                        grid:{
                            left:80,
                            right:50
                        },
                        series: [{
                            data: [],
                            type: 'bar',
                            barWidth: this.bar_width,
                            label: {
                                show: true,
                                position: 'top'
                            },
                            showBackground: this.bar_show_bg,
                            backgroundStyle: {
                                color: 'rgba(180, 180, 180, 0.2)'
                            }
                        },{
                            data: [],
                            type: 'line',
                            smooth: true,
                            color: '#0081ff'
                        }]
                    };

                    newVal.forEach((item)=>{
                        option.xAxis.data.push(item[this.name_key]);
                        option.series[0].data.push(item[this.value_key]);
                        if(this.line_value_key != ''){
                            option.series[1].data.push(item[this.line_value_key]);
                        }
                    });

                    this.myChart.setOption(option);
                    this.myChart.hideLoading();
                }
                else{
                    this.myChart.clear();
                }
            }
        }
    }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/myEcharsCol.vue